"use client";

import React from "react";
import {NotificationAction} from "@/components/notifications/NotificationAction";
import {NotificationIcon} from "@/components/notifications/NotificationIcon";
import {NotificationItem} from "@/components/notifications/NotificationItem";
import {resolveAccountNotificationContent} from "@/components/notifications/notificationContent";
import type {NotificationDictionary} from "@/components/notifications/NotificationDrawer";
import type {Locale} from "@/i18n-config";
import type {
    ReleaseNoteNotification,
    TextNotification as TextAccountNotification,
} from "@/utils/notifications/account/types";

export function TextNotification({
    notification,
    locale,
    dictionary,
    onMarkRead,
    onInternalNavigate,
}: {
    notification: ReleaseNoteNotification | TextAccountNotification;
    locale: Locale;
    dictionary: NotificationDictionary;
    onMarkRead: (notificationId: string) => void | Promise<void>;
    onInternalNavigate: () => void;
}) {
    const content = resolveAccountNotificationContent(
        notification,
        locale,
        dictionary,
    );
    const action = content.action;
    const actionClassName =
        "text-sm font-semibold text-grass-700 hover:text-grass-900";
    const icon = (
        <NotificationIcon
            type={notification.type}
            categoryKey={content.categoryKey}
        />
    );
    const actionView = action ? (
        <NotificationAction
            locale={locale}
            href={action.href}
            label={action.label}
            onActivate={() => onMarkRead(notification.id)}
            onInternalNavigate={onInternalNavigate}
            className={actionClassName}
        />
    ) : undefined;

    return (
        <NotificationItem
            id={notification.id}
            locale={locale}
            publishedAt={notification.published_at}
            readAt={notification.read_at}
            icon={icon}
            categoryKey={content.categoryKey}
            label={content.category}
            title={content.title}
            description={content.description}
            sticky={notification.sticky}
            stickyLabel={dictionary.notificationCenterPinned}
            action={actionView}
            markReadLabel={dictionary.notificationCenterMarkRead}
            showMoreLabel={dictionary.notificationCenterShowMore}
            showLessLabel={dictionary.notificationCenterShowLess}
            onMarkRead={onMarkRead}
        />
    );
}
